<template>
  <component :is="tag" :href="href" @click="$emit('click')" v-bind="attrs" class="hero-button-leaflet">
    <icon-map class="icon-map"></icon-map> <slot></slot>
  </component>
</template>

<script>
  import { IconMap } from "../ui/index"

  export default {
    name: "HeroButtonLeaflet",
    props: {
      tag: {
        type: String,
        default: "button"
      },
      href: {
        default: false
      }
    },
    computed: {
      attrs() {
        let {tag, ...attrs} = this.$attrs;

        return attrs
      }
    },
    components: { IconMap }
  }
</script>

<style lang="scss" scoped>
  @import "~@rawlplug/rawlplug-design-style-tokens/dist/scss/all";

  .hero-button-leaflet {
    border: none;
    outline: none;
    background-color: transparent;
    color: $color-rwl-white-100;
    fill: $color-rwl-white-100;
    display: inline-flex;
    align-items: center;
    font-size: $font-size-rwl-headline-6;
    line-height: $line-height-klr-headline-6;
    font-weight: $font-weight-light;
    cursor: pointer;
    opacity: 1;
    transition: all 100ms ease-in-out;
  }

  .icon-map {
    margin-right: 10px;
  }
</style>
